<template>
  <div class="bankruptcy">
    <el-form :model="form" ref="form" label-width="110px" class="demo-form">
      <el-row>
        <el-col :span="24">
          <el-form-item label="破产企业名称">
            <el-input v-model="form.name" style="width:98%"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item label="代理律师(主)">
            <el-select
              
              v-model="form.leadLawyer"
              placeholder="请选择"
              class="select"
              clearable
              filterable
            >
              <el-option
                v-for="item in Lawyer"
                :key="item.id"
                :label="item.nikename"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6"> </el-col>

        <el-col :span="6">
          <el-form-item label="破产项目来源">
            <el-select
              v-model="form.soure"
              placeholder="请选择"
              class="select"
              clearable
              filterable
            >
              <el-option
                v-for="item in SoureOptions"
                :key="item.id"
                :label="item.nikename"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item class="cder" label="开始时间">
            <el-date-picker
              class="select"
              v-model="form.starttime"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="起始"
              clearable
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item class="cder" label="结束时间">
            <el-date-picker
              clearable
              class="select"
              v-model="form.endtime"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="终止"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item>
        <div style="text-align: center">
          <el-button type="primary" @click="inputCase()">搜索</el-button>

          <el-button type="danger" @click="clickReset()">重置</el-button>
        </div>
      </el-form-item>
    </el-form>

    <el-table
      :data="tableData"
      :header-cell-style="{ textAlign: 'center' }"
      :cell-style="{ textAlign: 'center' }"
      style="width: 100%"
    >
      <el-table-column prop="name" label="破产企业名称"></el-table-column>
      <el-table-column prop="code" label="编号" width="180"></el-table-column>
      <el-table-column prop="soure" label="破产项目来源" width="180">
      </el-table-column>
      <el-table-column prop="cb_lvshi" label="代理律师" width="180">
      </el-table-column>
      <el-table-column prop="sh_lvshi" label="审核人/风控委" width="180">
        <template slot-scope="scope">
          {{ arrobjectToString(scope.row.sh_lvshi) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="collectiondate"
        label="收案时间"
        width="150"
        :formatter="formatTime"
      >
        <template slot-scope="scope">
          {{ formatTime(scope.row.collectiondate) }}
        </template></el-table-column
      >
      <el-table-column
        prop="createdate"
        label="提交时间"
        width="150"
        :formatter="formatTime"
        ><template slot-scope="scope">
          {{ formatTime(scope.row.createdate) }}
        </template></el-table-column
      >
      <el-table-column label="状态" width="100" prop="status">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 0" type="text" class="casestatus"
            >正常(已通过)</span
          >
          <span v-if="scope.row.status == 1" type="text" class="casesresult"
            >待审核</span
          >
          <span v-if="scope.row.status == 2" type="text" class="casesrefuse"
            >未通过</span
          >
          <span v-if="scope.row.status == -1" type="text" class="casesrefuse"
            >已删除</span
          >
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="300">
        <template slot-scope="scope">
          <el-button
            type="primary"
            plain
            size="small"
            @click="selectCase(scope.row.id)"
            >查看</el-button
          >
          <el-button
            type="success"
            plain
            size="small"
            @click="passCase(scope.row.id)"
            v-if="
              scope.row.status == 1 &&
              $store.state.rolesname.includes('bankruptcy_pass')
            "
            >通过</el-button
          >
          <el-button
            type="warning"
            plain
            size="small"
            @click="rejectCase(scope.row.id)"
            v-if="
              scope.row.status == 1 &&
              $store.state.rolesname.includes('bankruptcy_reject')
            "
            >驳回</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[1, 5, 10, 15, 20]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>

    <el-dialog
      title="详情"
      :visible.sync="detailsDialog"
      width="50%"
      style="text-align: center"
    >
      <el-form
        :model="dialogForm"
        :rules="rules"
        ref="dialogForm"
        label-width="150px"
        class="demo-form"
      >
        <el-form-item label="破产企业名称" prop="name">
          <el-input disabled v-model="dialogForm.name"></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="代理律师(主)" prop="leadLawyer">
              <el-select
                style="width: 100%"
                v-model="dialogForm.leadLawyer"
                placeholder="请选择"
                class="select"
                clearable
                filterable
                @change="LeadLawyerChange(dialogForm.leadLawyer)"
                disabled
              >
                <el-option
                  v-for="item in Lawyer"
                  :key="item.id"
                  :label="item.nikename"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="代理律师(副)" prop="coCounsel">
              <el-select
                style="width: 100%"
                v-model="dialogForm.coCounsel"
                placeholder="请选择"
                class="select"
                clearable
                multiple
                filterable
                disabled
              >
                <el-option
                  v-for="item in Lawyer"
                  :key="item.id"
                  :label="item.nikename"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="破产项目来源" prop="soure">
              <el-select
                style="width: 100%"
                v-model="dialogForm.soure"
                placeholder="请选择"
                class="select"
                clearable
                filterable
                disabled
              >
                <el-option
                  v-for="item in SoureOptions"
                  :key="item.nikename"
                  :label="item.label"
                  :value="item.nikename"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="收案日期" prop="approvaldate">
              <div
                class="date_box"
                @mouseover="onMouseOver()"
                @mouseleave="onMouseleave()"
              >
                <el-date-picker
                  style="width: 100%"
                  v-model="dialogForm.approvaldate"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="请选择"
                  clearable
                  disabled
                >
                </el-date-picker>
                <i class="el-icon-date" ref="iconDate"></i>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="部门审批人"
              prop="caseLeaders"
              key="caseLeaders"
            >
              <el-select
                style="width: 100%"
                v-model="dialogForm.caseLeaders"
                placeholder="请选择"
                class="select"
                filterable
                clearable
                disabled
              >
                <el-option
                  v-for="item in CaseLeaders"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="二次审批人" prop="level">
              <el-select
                style="width: 100%"
                v-model="dialogForm.level"
                placeholder="请选择"
                class="select"
                clearable
                filterable
                disabled
              >
                <el-option
                  v-for="item in Level"
                  :key="item.id"
                  :label="item.nikename"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="用章类型" prop="sealtype">
          <el-select
            style="width: 100%"
            v-model="dialogForm.sealtype"
            placeholder="请选择"
            class="select"
            clearable
            filterable
            disabled
          >
            <el-option
              v-for="item in Seal"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <div style="text-align: center">
            <el-button
              type="success"
              plain
              @click="passCase(dialogForm.id)"
              v-if="
                dialogForm.status == 1 &&
                $store.state.rolesname.includes('bankruptcy_pass')
              "
              >通过</el-button
            >
            <el-button
              type="warning"
              plain
              @click="rejectCase(dialogForm.id)"
              v-if="
                dialogForm.status == 1 &&
                $store.state.rolesname.includes('bankruptcy_reject')
              "
              >驳回</el-button
            >
            <el-button type="warning" @click="detailsDialog = false"
              >关闭</el-button
            >
          </div>
        </el-form-item>
         <!-- 冲突案件 -->
      <div class="conflict">
        <div class="top">
          <div class="icon"></div>
          <div>
            案件冲突<span
              style="color: black; font-size: 14px; margin-left: 10px"
              >(<span style="color: blue">蓝色</span>为代理方,
              <span style="color: red; font-weight: 900">!</span
              >橙色代表冲突方，灰色背景是导入数据)</span
            >
          </div>
        </div>
        <el-table
          :data="caseConflictData"
          style="width: 95%; margin-left: 2%"
          :header-cell-style="{ textAlign: 'center' }"
          :cell-style="{ textAlign: 'center' }"
          :row-class-name="tableRowClass"
        >
          <el-table-column prop="code" label="案件编号" width="150">
          </el-table-column>
          <el-table-column prop="title" label="案件名称" width="300">
          </el-table-column>
          <el-table-column prop="litigant" label="当事人">
            <template slot-scope="scope">
              <div
                v-for="(c, index) in scope.row.litigant"
                class="litigant-container"
              >
                {{ c.attribute }}：
                <span
                  v-for="(item, index) in c.all"
                  :key="item.id"
                  style="display: inline"
                >
                  <span v-if="item.isshow" style="color: red; font-weight: 900"
                    >!</span
                  >
                  <span
                    :style="{
                      color: getRandomColor(item.isClient, item.isshow),
                    }"
                    >{{ item.name }}</span
                  >
                  <span v-if="index < c.all.length - 1">, </span>
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="冲突对象">
            <template slot-scope="scope">
              {{ GetNameIdnumber(scope.row.litigant) }}
            </template>
          </el-table-column>
          <el-table-column prop="entrustmentTime" label="委托时间" width="150">
            <template slot-scope="scope">
              {{ formatTime(scope.row.entrustmentTime) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150" fixed="right">
            <template slot-scope="scope">
              <el-button
                class="copy"
                @click="conflictClick(scope.row)"
                v-if="!scope.row.isOther"
                >查看</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <div v-if="hasMore" style="text-align: center">
          <el-button type="text" @click="showAllCaseClick">
            {{ showAllCase ? "收起" : `查看更多` }}
          </el-button>
        </div>
      </div>
      </el-form>

    </el-dialog>

      <!-- 冲突预览 -->
       <el-dialog
      center
      title="预览"
      :visible.sync="isChong"
      append-to-body
      class="file-dialog"
      width="85%"
      @close="closChong"
    >
      <el-form class="form" ref="formrefCT" :model="CTform" label-width="200px">
        <!-- 案件当事人 -->
        <div
          v-if="
            chongCaseType == 1 ||
            chongCaseType == 2 ||
            chongCaseType == 3 ||
            chongCaseType == 4 ||
            chongCaseType == 5 ||
            chongCaseType == 6||chongCaseType == 9
          "
          style="width: 90%"
        >
          <div class="divider"></div>
          <div class="top">
            <div class="icon"></div>
            <div>案件当事人</div>
          </div>
          <el-row>
            <el-table
              class="party"
              border
              :data="CTform.tableData"
              style="width: calc(100% - 61px);"
              :header-cell-style="{ textAlign: 'center' }"
              :cell-style="{ textAlign: 'center' }"
              :row-class-name="tableRowClassName"
            >
              <el-table-column
                label="属性"
                prop="attribute"
                :render-header="addRedStar"
                width="160"
              >
                <!-- <template slot-scope="scope">
                  <el-select
                    size="mini"
                    v-model="scope.row.attribute"
                    clearable
                    filterable
                    disabled
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in ArrtibuteOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </template> -->
              </el-table-column>
              <el-table-column
                label="类型"
                prop="isUnit"
                :render-header="addRedStar"
                width="100"
              >
                <template slot-scope="scope">
                  <el-select
                    size="mini"
                    v-model="scope.row.isUnit"
                    clearable
                    disabled
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in typeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                label="姓名/单位名称"
                prop="name"
                :render-header="addRedStar"
                :show-overflow-tooltip="true"
                min-width="360"
              >
              </el-table-column>
              <el-table-column
                label="身份证号/社会信用代码"
                prop="name"
                :show-overflow-tooltip="true"
                min-width="360"
              >
              </el-table-column>
              <el-table-column
                label="委托方"
                prop="isClient"
                :render-header="addRedStar"
                width="80"
              >
                <template slot-scope="scope">
                  <el-checkbox
                    :disabled="bianji"
                    v-model="scope.row.isClient"
                    @change="clientChange(scope.row)"
                  ></el-checkbox>
                </template>
              </el-table-column>

             
            </el-table>
          </el-row>
        </div>

        <div class="text">
          <div style="width: 90%">案件信息：{{ CTform.title }}</div>
        </div>
        <div
          v-if="
            chongCaseType == 1 ||
            chongCaseType == 2 ||
            chongCaseType == 3 ||
            chongCaseType == 4 ||
            chongCaseType == 5 ||
            chongCaseType == 6
          "
          style="width: 90%"
        >
          <el-row>
            <el-col :span="24">
              <el-form-item label="案件名称" prop="title">
                <el-input
                  v-model="CTform.title"
                  placeholder="请输入"
                  clearable
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" v-if="chongCaseType == 3">
              <el-form-item label="公益诉讼" prop="public_welfare">
                <el-select
                  v-if="CTform.bcz != null"
                  v-model="CTform.bcz.public_welfare"
                  placeholder="请选择"
                  class="select"
                  clearable
                  disabled
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="受理机构案号" prop="acceptcode">
                <el-input
                  v-model="CTform.acceptcode"
                  placeholder="请输入"
                  clearable
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="案件编号" prop="code">
                <el-input
                  v-model="CTform.code"
                  placeholder="自动编号"
                  disabled
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12" v-if="chongCaseType != 4">
              <el-form-item label="法律援助" prop="assist">
                <el-select
                  v-model="CTform.assist"
                  placeholder="请选择"
                  class="select"
                  clearable
                  disabled
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in Flyz"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="案卷状态" prop="ajstatus">
                <el-select
                  v-model="CTform.ajstatus"
                  placeholder="请选择"
                  class="select"
                  clearable
                  disabled
                  style="width: 100%"
                  @change="inputType(form.ajstatus, null)"
                >
                  <el-option
                    v-for="item in Ajstatus"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    style="width: 100%"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="false">
            <el-col :span="10">
              <el-form-item label="受理状态" prop="casestatus">
                <el-select
                  disabled
                  v-model="CTform.casestatus"
                  placeholder="请选择"
                  class="select"
                  clearable
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in CaseStatus"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-button
                size="small"
                @click="Accept()"
                style="margin-left: 10px; margin-top: 4px"
                v-if="CTform.casestatus == '未受理' && bianji && form.uid"
                type="primary"
                plain
                >点此受理</el-button
              >
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12" class="date_box">
              <el-form-item label="收案日期" prop="approvaldate">
                <div
                  class="date_box"
                  @mouseover="onMouseOver()"
                  @mouseleave="onMouseleave()"
                >
                  <el-date-picker
                    style="width: 100%"
                    v-model="CTform.approvaldate"
                    value-format="yyyy-MM-dd"
                    type="date"
                    placeholder="系统自动生成"
                    clearable
                    disabled
                  >
                  </el-date-picker>
                  <!-- <i class="el-icon-date" ref="iconDate"></i> -->
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="案件来源" prop="source">
                <el-input
                  v-model="CTform.source"
                  placeholder="请输入"
                  clearable
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="受理机构" prop="acceptUnit">
                <el-input
                  v-model="CTform.acceptUnit"
                  placeholder="请输入"
                  clearable
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="案由" prop="cause">
                <el-input
                  v-model="CTform.cause"
                  placeholder="请输入"
                  clearable
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="代理律师" prop="leadLawyer">
                <el-select
                  style="width: 100%"
                  v-model="CTform.leadLawyer"
                  placeholder="请选择"
                  class="select"
                  clearable
                  multiple
                  :multiple-limit="1"
                  @change="LeadLawyerChange(CTform.leadLawyer)"
                  disabled
                >
                  <el-option
                    v-for="item in Lawyer"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                    disabled
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="false">
              <el-form-item
                label="委托事项"
                prop="remark"
                v-if="chongCaseType != 2"
              >
                <el-select
                  style="width: 100%"
                  v-model="CTform.remark"
                  placeholder="请选择"
                  class="select"
                  clearable
                  disabled
                >
                  <el-option
                    v-for="item in Entrust"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                v-if="chongCaseType == 2"
                label="介入阶段"
                prop="intervene"
              >
                <el-select
                  filterable
                  v-if="CTform.bcz != null"
                  style="width: 100%"
                  v-model="CTform.bcz.intervene"
                  placeholder="请选择"
                  class="select"
                  clearable
                  disabled
                >
                  <el-option
                    v-for="item in Intervene"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="chongCaseType == 2">
            <el-col :span="12" v-if="CTform.result == 1">
              <el-form-item label="刑事风险控制人" prop="criminalrisk">
                <el-select
                  style="width: 100%"
                  v-model="CTform.criminalrisk"
                  placeholder="请选择"
                  class="select"
                  clearable
                  disabled
                  @change="bmzgChange"
                >
                  <el-option
                    v-for="item in Criminal"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12"> </el-col>
          </el-row>
          <el-row>
            <el-col
              :span="12"
              v-if="
                chongCaseType != 7 &&
                chongCaseType != 8 &&
                chongCaseType != 14 &&
                chongCaseType != 9 &&
                CTform.result == 1
              "
            >
              <el-form-item label="二次审批人" prop="level">
                <el-select
                  filterable
                  style="width: 100%"
                  v-model="CTform.level"
                  placeholder="请选择"
                  class="select"
                  clearable
                  disabled
                  multiple
                  :multiple-limit="1"
                  @change="bmzgChange"
                >
                  <el-option
                    v-for="item in Level"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="代理律师" prop="coCounsel">
                <el-select
                  filterable
                  style="width: 100%"
                  v-model="CTform.coCounsel"
                  placeholder="请选择"
                  class="select"
                  clearable
                  multiple
                  disabled
                >
                  <el-option
                    v-for="item in Lawyer"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                    disabled
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="CTform.result == 1">
            <el-form-item label="部门主管" prop="caseLeaderscase">
              <el-select
                filterable
                placeholder="请选择"
                clearable
                v-model="CTform.caseLeaderscase"
                @change="bmzgChange"
              >
              
                <el-option
                  v-for="item in CaseLeaders"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-row>
        </div>

        <div v-else style="width: 90%">
          <el-row>
            <el-col :span="24">
              <el-form-item label="项目名称" prop="title">
                <el-input v-model="CTform.title" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-form-item label="受理机构案号" prop="acceptcode">
              <el-input
                v-model="CTform.acceptcode"
                placeholder="请输入"
                clearable
                :disabled="bianji"
              ></el-input>
            </el-form-item>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="项目概要" prop="cause">
                <el-input
                  v-model="CTform.cause"
                  placeholder="请输入"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="14">
              <el-form-item label="案件编号" prop="code">
                <el-input
                  v-model="CTform.code"
                  placeholder="自动编号"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="案卷状态" prop="ajstatus" v-if="chongCaseType != 12 && chongCaseType !=13">
                <el-select
                  v-model="CTform.ajstatus"
                  placeholder="请选择"
                  class="input"
                  style="width: 100%"
                  disabled
                  @change="inputType(form.ajstatus, null)"
                >
                  <el-option
                    v-for="item in Ajstatus"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="破产案件类型" prop="bcz.projecttype" v-if="chongCaseType == 12">
                    <el-select
                      style="width: 100%"
                      v-model="CTform.bcz.projecttype"
                      placeholder="请选择"
                      class="select"
                      disabled
                    >
                      <el-option
                        v-for="item in ProjectType"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="false">
            <el-col :span="12">
              <el-form-item label="受理状态" prop="casestatus">
                <el-select
                  disabled
                  v-model="CTform.casestatus"
                  placeholder="请选择"
                  class="select"
                  clearable
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in CaseStatus"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-button
                size="small"
                @click="Accept()"
                style="margin-left: 20px"
                v-if="CTform.casestatus == '未受理' && bianji && CTform.uid"
                type="primary"
                plain
                >点此受理</el-button
              >
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="14">
              <el-form-item label="项目合伙人" prop="partner">
                <el-input
                  v-if="CTform.bcz != null"
                  v-model="CTform.bcz.partner"
                  placeholder="请输入"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="底稿资料" prop="draft">
                <el-select
                  v-if="CTform.bcz != null"
                  v-model="CTform.bcz.draft"
                  placeholder="请选择"
                  class="select"
                  disabled
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in Draft"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 一般非诉项目、单独出具律师意见审批书、单独出具律师函没有二次审批人 -->
          <el-row
            v-if="
              chongCaseType != 7 &&
              chongCaseType != 8 &&
              chongCaseType != 14 &&
              chongCaseType != 9 &&
              (form.result == 1 || bianji == false)
            "
            style="width: 90%"
          >
            <el-col :span="14">
              <el-form-item label="二次审批人" prop="level">
                <el-select
                  style="width: 100%"
                  v-model="CTform.level"
                  class="select"
                  multiple
                  :multiple-limit="1"
                  disabled
                  @change="bmzgChange"
                >
                  <el-option
                    v-for="item in Level"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="divider"></div>
          <el-row>
            <el-col :span="14" class="date_box">
              <el-form-item label="立项日期" prop="approvaldate">
                <el-date-picker
                  style="width: 100%"
                  v-model="CTform.approvaldate"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="系统自动生成"
                  disabled
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="项目来源" prop="source">
                <el-input
                  v-model="CTform.source"
                  placeholder="请输入"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="14">
              <el-form-item
                :label="chongCaseType == 10 ? '代理机构' : '受理机构'"
                prop="acceptUnit"
                v-if="chongCaseType == 10"
              >
                <el-input v-model="CTform.acceptUnit" disabled></el-input>
              </el-form-item>
              <el-form-item
                :label="chongCaseType == 12 ? '管辖法院' : '受理机构'"
                v-if="chongCaseType != 10"
              >
                <el-input v-model="CTform.acceptUnit" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col
              :span="10"
              v-if="
                chongCaseType == 7 ||
                chongCaseType == 8 ||
                chongCaseType == 14 ||
                chongCaseType == 9 ||
                chongCaseType == 11
              "
            >
              <el-form-item label="项目分类" prop="classification">
                <el-input
                  v-if="CTform.bcz != null"
                  v-model="CTform.bcz.classification"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10" v-if="chongCaseType == 10">
              <el-form-item label="项目类型" prop="projecttype">
                <el-select
                  v-if="CTform.bcz != null"
                  style="width: 100%"
                  v-model="CTform.bcz.projecttype"
                  disabled
                >
                  <el-option
                    v-for="item in Projecttype"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="10" v-if="chongCaseType == 12">
              <el-form-item label="案件级别" >
                <el-select style="width: 100%" v-model="CTform.bcz.caselevel" placeholder="请选择" class="select" disabled>
                    <el-option v-for="item in Level" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="14">
              <el-form-item
                :label="chongCaseType == 10 ? '服务律师' : '代理律师'"
                prop="leadLawyer"
              >
                <el-select
                  filterable
                  style="width: 100%"
                  v-model="CTform.leadLawyer"
                  class="select"
                  multiple
                  :multiple-limit="1"
                  @change="LeadLawyerChange(CTform.leadLawyer)"
                  disabled
                >
                  <el-option
                    v-for="item in Lawyer"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                    disabled
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="14">
              <el-form-item label="代理律师" prop="coCounsel">
                <el-select
                  filterable
                  style="width: 100%"
                  v-model="CTform.coCounsel"
                  placeholder="请选择"
                  class="select"
                  clearable
                  multiple
                  disabled
                >
                  <el-option
                    v-for="item in Lawyer"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                    disabled
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            v-if="
              (chongCaseType == 7 ||
                chongCaseType == 8 ||
                chongCaseType == 14 ||
                chongCaseType == 9) &&
              CTform.result == 1
            "
          >
            <el-col :span="14">
              <el-form-item label="风控委" prop="level">
                <el-select
                  filterable
                  style="width: 100%"
                  v-model="CTform.level"
                  class="select"
                  multiple
                  :multiple-limit="2"
                  disabled
                >
                  <el-option
                    v-for="item in FKW"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="CTform.result == 1">
            <el-form-item label="部门主管" prop="caseLeaderscase">
              <el-select
                filterable
                style="width: 100%"
                v-model="CTform.caseLeaderscase"
                placeholder="请选择"
                class="select"
                clearable
                @change="bmzgChange"
              >
                <el-option
                  v-for="item in CaseLeaders"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <!-- 与其他法律服务有关的招投标项目栏独有字段 -->
          <div v-if="chongCaseType == 10">
            <el-row>
              <el-col :span="14">
                <el-form-item label="开放时间" prop="opentime">
                  <el-date-picker
                    v-if="CTform.bcz != null"
                    style="width: 100%"
                    v-model="CTform.bcz.opentime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    disabled
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="采购方式" prop="procuremethod">
                  <el-input
                    v-if="CTform.bcz != null"
                    v-model="CTform.bcz.procuremethod"
                    placeholder="请输入"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="14">
                <el-form-item label="预算金额" prop="budgetmoney">
                  <el-input
                    v-if="CTform.bcz != null"
                    v-model="CTform.bcz.budgetmoney"
                    placeholder="请输入"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="采购编号" prop="procurecode">
                  <el-input
                    v-if="CTform.bcz != null"
                    v-model="CTform.bcz.procurecode"
                    placeholder="请输入"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- 专项服务合同独有字段 -->
          <div v-if="chongCaseType == 11">
            <el-row>
              <el-col :span="14">
                <el-form-item label="合同服务类型" prop="contracttype">
                  <el-input
                    v-if="CTform.bcz != null"
                    v-model="CTform.bcz.contracttype"
                    placeholder="请输入"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="服务期限" prop="servicetime">
                  <el-date-picker
                    v-if="CTform.bcz != null"
                    style="width: 100%"
                    v-model="CTform.bcz.servicetime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    disabled
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div v-if="chongCaseType == 12">
            <el-row>
                <el-col :span="14">
                  <el-form-item label="项目负责人" >
                    <el-input v-model="CTform.bcz.porjectleader" placeholder="请输入" disabled></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item label="委托人摇号" >
                    <el-input v-model="CTform.bcz.lottery" placeholder="请输入" disabled></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="14">
                  <el-form-item label="管理人账号" >
                    <el-select style="width: 100%" v-model="CTform.bcz.administrator" placeholder="请选择"
                      class="select" disabled>
                      <el-option v-for="item in Administrator" :key="item.value" :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="!CTform.bcz.administrator">
                  <el-col :span="14">
                    <el-form-item label="开户账号" >
                      <el-input v-model="CTform.bcz.account" placeholder="请输入" disabled></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10">
                    <el-form-item label="开户银行" >
                      <el-input v-model="CTform.bcz.bank" placeholder="请输入" disabled></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
          </div>
          <div class="divider"></div>

          <el-row v-if="chongCaseType!=9">
            <el-col :span="14">
              <el-form-item v-if="chongCaseType!=12"
                :label="chongCaseType == 10 ? '采购单位' : '客户名称'"
                prop="bcz.procureunit"
              >
                <el-input
                  v-if="CTform.bcz != null"
                  v-model="CTform.bcz.procureunit"
                  placeholder="请输入"
                  disabled
                ></el-input>
              </el-form-item>
              <el-form-item label="债务人名称" prop="bcz.debtorName" v-if="chongCaseType==12">
                      <el-input
                        v-model="CTform.bcz.debtorName"
                        placeholder="请输入"
                        disabled
                      ></el-input>
                    </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="身份证号/社会信用代码" prop="bcz.idnumber" v-if="chongCaseType!=10">
                      <el-input
                        v-model="CTform.bcz.idnumber"
                        placeholder="请输入"
                        disabled
                      ></el-input>
                    </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  caseLawyerApi,
  oldSelect,
  examineCase,
  caseSuccess,
  reject,
   BKCaseConflict,
  allCaseApi,
} from '../../api/case'
import { GetDepartmentLeaders } from '../../api/bankrupt'
import { user } from '../../api/seal'
export default {
  name: 'bankruptcyManagerCheck',
  data() {
    var ajstatusCheck = (rule, value, callback) => {
      if (value == null || value === undefined || value == '' || value == []) {
        callback(new Error('请输入或选择！'))
      }
      callback()
    }
    return {
      form: {
        name: null,
        leadLawyer: null,
        soure: null,
        starttime: null,
        endtime: null,
        status: null
      },
      dialogForm: {
        id: null,
        name: null,
        leadLawyer: null,
        coCounsel: null,
        soure: null,
        approvaldate: null,
        caseLeaders: null,
        level: null,
        sealtype: null,
        status: null
      },

      rules: {
        name: [
          {
            required: true,
            validator: ajstatusCheck,
            trigger: ['blur', 'change']
          }
        ],
        leadLawyer: [
          {
            required: true,
            validator: ajstatusCheck,
            trigger: ['blur', 'change']
          }
        ],
        soure: [
          {
            required: true,
            validator: ajstatusCheck,
            trigger: ['blur', 'change']
          }
        ],
        approvaldate: [
          {
            required: true,
            validator: ajstatusCheck,
            trigger: ['blur', 'change']
          }
        ],
        caseLeaders: [
          {
            required: true,
            validator: ajstatusCheck,
            trigger: ['blur', 'change']
          }
        ],
        level: [
          {
            required: true,
            validator: ajstatusCheck,
            trigger: ['blur', 'change']
          }
        ],
        sealtype: [
          {
            required: true,
            validator: ajstatusCheck,
            trigger: ['blur', 'change']
          }
        ]
      },

      SoureOptions: [
        { label: '投标', nikename: '投标' },
        { label: '指定', nikename: '指定' }
      ],
     States: [
        { label: "正常(审核通过)", nikename: 0},
        { label: "审核中", nikename: 1 },
        { label: "审核未通过", nikename: 2 },
        { label: "删除", nikename: -1 },
      ],
      // 代理律师
      Lawyer: [],
      // 部门审批人
      CaseLeaders: [],
      // 二次审批人
      Level: [],
      // 用章类型
      Seal: [
        { value: 'contract_seal', label: '合同章' },
        { value: 'corporate_seal', label: '法人章' },
        { value: 'official_seal', label: '公章' },
        { label: '公章+法人章', value: 'official_corporate_seal' },
        { label: '合同章+法人章', value: 'contract_corporate_seal' },
        { label: '法律意见书专用章', value: 'law_seal' },
        { label: '律师函专用章', value: 'legal_letter_seal' }
      ],

      // 分页
      currentPage: 1,
      pageSize: 10,
      total: 0,

      // 回显
      tableData: [],

      detailsDialog: false,
      dlb: false,

      caseConflictData: [], //冲突案件
      showAllCase: false, //是否显示全部冲突案件
      hasMore: false,
      allConflictCase: [], //所有的冲突案件

      chongCaseType:'',
      isChong:false,//案件冲突详情弹出框
      CTform:{
        bcz:{
          idnumber:null,
        }
      },
      // 法律援助
      Flyz: [
        { label: '是', value: true },
        { label: '否', value: false }
      ],
       // 项目类型
       Projecttype: [ { label: '政府采购', value: 0 },
        { label: '国企采购', value: 1 },
        { label: '其他社会采购', value: 2 }],
      // 单位/个人
      typeOptions: [
        { value: true, label: '个人' },
        { value: false, label: '单位' }
      ],
      ProjectType: [{ label: "重整案件", value: "重整案件" }, { label: "预重整", value: "预重整" }, { label: "公益案件", value: "公益案件" }],
      bianji: true, 
      Draft: [
        { label: '已归档', value: true },
        { label: '未归档', value: false }
      ], //底稿资料
      // 案卷状态
      Ajstatus: [
        { label: '一审', value: '一审' },
        { label: '二审', value: '二审' },
        { label: '再审', value: '再审' },
        { label: '破产申报', value: '破产申报' },
        { label: '再审听证', value: '再审听证' },
        { label: '行政复议', value: '行政复议' },
        { label: '首次执行', value: '首次执行' },
        { label: '恢复执行', value: '恢复执行' },
        { label: '执行异议', value: '执行异议' },
        { label: '仲裁阶段', value: '仲裁阶段' },
        { label: '侦查阶段', value: '侦查阶段' },
        { label: '审查起诉', value: '审查起诉' },
        { label: '无', value: '无' }
        // { label: '受理', value: '受理' },
        // { label: '未受理', value: '未受理' }
      ],
      // 公益诉求
      options: [
        { value: 0, label: '是' },
        { value: 1, label: '否' }
      ],
    }
  },

  methods: {
    // 通过
    passCase(id) {
      //Success
      caseSuccess({
        Id: id,
        Reason: null
      })
        .then((res) => {
          if (res.data.status == 'success') {
            this.$message.success('审核成功')
            this.inputCase()
          } else if (
            res.data.status == '401' ||
            res.data.status == '402' ||
            res.data.status == '403'
          ) {
            this.$message.error(res.data.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            this.$router.push('/login')
            return
          } else {
            this.$message.error(res.data.message)
          }
        })
        .catch(() => {
          this.$message.error('前台错误！')
        })
    },
    // 驳回
    rejectCase(id) {
      //Reject
      reject({
        Id: id,
        Reason: null
      })
        .then((res) => {
          if (res.data.status == 'success') {
            this.$message.success('审核成功')
            this.inputCase()
          } else if (
            res.data.status == '401' ||
            res.data.status == '402' ||
            res.data.status == '403'
          ) {
            this.$message.error(res.data.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            this.$router.push('/login')
            return
          } else {
            this.$message.error(res.data.message)
          }
        })
        .catch(() => {
          this.$message.error('前台错误！')
        })
    },
    // 代理律师/申请人/代理律师
    GetLawyer() {
      caseLawyerApi({}).then((res) => {
        if (res.data.status == 'success') {
          this.Lawyer = res.data.data
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
          return
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    // 获取案件审核部门主管
    GetDepartmentLeaders(lvshi) {
      if (lvshi == '' || lvshi == null) {
        return
      }

      GetDepartmentLeaders({
        Id: lvshi
      }).then((res) => {
        if (res.data.status == '0') {
          this.CaseLeaders = res.data.data
          var index = this.CaseLeaders.findIndex((item) => {
            return item.value == this.form.caseLeaders
          })
          // console.log("index:"+index)
          if (index == -1) {
            //不存在，清空
            this.form.caseLeaders = ''
          }
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
          return
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    // 案件二次审批人/用章二次审批人
    GetLevel(lvshi) {
      if (lvshi == '' || lvshi == null) {
        return
      }
      user({
        Id: this.form.leadLawyer,
        apporver: 'case_00000000-0011-0011-0012-000000000000'
      }).then((res) => {
        if (res.data.status == 'success') {
          this.Level = res.data.data
          var index = this.Level.findIndex((item) => {
            return item.id == this.form.level
          })
          if (index == -1) {
            //不存在，清空二次审批人
            this.form.level = ''
          }
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
          return
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    // 代理律师 改变
    LeadLawyerChange(lvshi) {
      this.GetDepartmentLeaders(lvshi)
      this.GetLevel(lvshi)
    },

    // 重置
    clickReset() {
      this.form.name = null
      this.form.leadLawyer = null
      this.form.soure = null
      this.form.starttime = null
      this.form.endtime = null
      this.form.status = null
    },

    // 承办律师
    arrToString(arr) {
      return arr.join(' , ')
    },
    // 审核人/风控委
    arrobjectToString(arrobject) {
      var s = ''
      arrobject.forEach((value, index) => {
        // s += value.nikename
        // if (index < arrobject.length - 1) {
        //   s = s + '，'
        // }

        s += value
        if (index < arrobject.length - 1) {
          s = s + '，'
        }
      })
      return s
    },

    // 分页查询
    handleSizeChange(val) {
      this.pageSize = val
      this.inputCase()
    },
    // 分页查询
    handleCurrentChange(val) {
      this.currentPage = val
      this.inputCase()
    },

    // 查询
    inputCase() {
      examineCase({
        name: this.form.name == '' ? null : this.form.name,
        leadLawyer: this.form.leadLawyer == '' ? null : this.form.leadLawyer,
        soure: this.form.soure == '' ? null : this.form.soure,
        starttime: this.form.starttime == '' ? null : this.form.starttime,
        endtime: this.form.endtime == '' ? null : this.form.endtime,
        status: this.form.status == '' ? null : this.form.status,
        page: this.currentPage,
        rows: this.pageSize
      })
        .then((res) => {
          if (res.data.status == 'success') {
            this.total = res.data.total
            this.tableData = res.data.data
          }
        })
        .catch((err) => {
          console.log('查询失败', err)
        })
    },

    // 明细查询
    selectCase(id) {
      oldSelect({ bkid: id })
        .then((res) => {
          if (res.data.data != null) {
            this.dialogForm.id = res.data.data[0].id
            this.dialogForm.approvaldate = this.formatTime(
              res.data.data[0].collectionDate
            )
            this.dialogForm.coCounsel = res.data.data[0].deputyLawyer
            this.dialogForm.leadLawyer = res.data.data[0].mainLawyer
            this.dialogForm.name = res.data.data[0].name
            this.dialogForm.soure = res.data.data[0].soure
            this.dialogForm.status = res.data.data[0].status
            this.dialogForm.caseLeaders = res.data.data[0].sh_lvshi[0].memberId
            this.dialogForm.level = res.data.data[0].sh_lvshi[1].memberId
            this.dialogForm.sealtype = res.data.data[0].sealType
            this.detailsDialog = true
            this.CaseConflictSelect(); //获取冲突案件
            if (res.data.data[0].status != 2) {
              // 不可编辑
              this.dlb = true
            }
          }
        })
        .catch(() => {})
    },
    // --时间格式转换--
    formatTime(row) {
      const date = new Date(row)
      // return row[column.property].Format('yyyy-MM-dd HH:mm')
      var year = date.getFullYear()
      /* 在日期格式中，月份是从0开始的，因此要加0
       * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
       * */
      var month =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1
      var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
      var minutes =
        date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      var seconds =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      // 拼接
      if (hours == '00' && minutes == '00' && seconds == '00') {
        return year + '-' + month + '-' + day
      } else {
        return (
          year + '-' + month + '-' + day
          // +
          // ' ' +
          // hours +
          // ':' +
          // minutes +
          // ':' +
          // seconds
        )
      }
    },

    onMouseOver() {
      if (this.dialogForm.approvaldate != undefined) {
        this.$refs.iconDate.style.display = 'none'
      }
    },
    onMouseleave() {
      this.$refs.iconDate.style.display = 'block'
    },
    tableRowClass({ row, rowIndex }) {
      console.log("isoth", row.isOther);
      if (row.isOther) {
        return "beig-row";
      } else {
        return "";
      }
    },
    GetNameIdnumber(data) {
      const filtered = data.flatMap((item) =>
        item.all
          .filter((person) => person.isshow)
          .map((person) => ({
            name: person.name,
            idnumber: person.idnumber,
          }))
      );
    },
    showAllCaseClick() {
      if (this.showAllCase) {
        this.showAllCase = false;
        this.caseConflictData = this.allConflictCase.filter(
          (item) => item.isClient == 1
        ); //所有有冲突的案件
        if (this.caseConflictData.length == 0) {
          //没有冲突案件
          this.caseConflictData.push(this.allConflictCase[0]);
        }
      } else {
        this.caseConflictData = this.allConflictCase;
        this.showAllCase = true;
      }
    },
    //案件冲突
    CaseConflictSelect() {
      this.hasMore = false
      BKCaseConflict({
        name: this.dialogForm.name,
        idnumber: this.dialogForm.idnumber,
      }).then((res) => {
        if (res.data.status == "success") {
          // 弹出案件冲突
          if (res.data.data.length > 0) {
            this.allConflictCase = res.data.data;

            this.caseConflictData = this.allConflictCase.filter(
              (item) => item.isClient == 1
            ); //所有有冲突的案件
            if (this.caseConflictData.length == 0) {
              //没有冲突案件
              this.caseConflictData.push(this.allConflictCase[0]);
            }
            if (
              this.allConflictCase.length > this.caseConflictData.length &&
              this.allConflictCase.length > 1
            ) {
              this.hasMore = true;
            }
          }
        } else if (
          res.data.status == "401" ||
          res.data.status == "402" ||
          res.data.status == "403"
        ) {
          this.$message.error(res.data.message);
          window.sessionStorage.removeItem("token");
          window.sessionStorage.removeItem("hasRoles");
          this.$router.push("/login");
          return;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    getRandomColor(item, show) {
      if (show) return "#e86e30";
      else if (item) return "blue";
    },
    conflictClick(row) {
      this.chongCaseType = row.typeId.substring(21, 23);
      allCaseApi({
        Id: row.id,
        SelectType: 1, //（0：案件管理，1：案件明细）
      }).then((res) => {
        if (res.data.status == "0") {
          // 案件信息
          this.CTform = res.data.data[0];

          //其他东西
          this.CTform.bcz = JSON.parse(res.data.data[0].bcz);
          for (var i = 0; i < this.CTform.biddingSchemes.length; i++) {
            var name = this.CTform.biddingSchemes[i].name.split(".")[0];
            var type = this.CTform.biddingSchemes[i].name.substring(
              this.CTform.biddingSchemes[i].name.lastIndexOf(".") + 1
            );
          }
          this.isChong = true;
        } else if (
          res.data.status == "401" ||
          res.data.status == "402" ||
          res.data.status == "403"
        ) {
          this.$message.error(res.data.message);
          window.sessionStorage.removeItem("token");
          window.sessionStorage.removeItem("hasRoles");
          this.$router.push("/login");
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    closChong() {
      this.isChong = false
    },
     // 必选标识
    addRedStar(h, { column }) {
      return [
        h('span', { style: 'color: #F56C6C' }, '*'),
        h('span', ' ' + column.label)
      ]
    },
    // 案件当事人背景颜色
      tableRowClassName({ row, rowIndex }) {
      // console.log(row.isClient)
      if (row.isClient||row.isClient) {
        return 'isclient-row'
      } else {
        return ''
      }
    },
  },

  created() {
    this.GetLawyer()
    this.inputCase()
  },

  watch: {
    'dialogForm.leadLawyer': {
      handler(newValue, oldValue) {
        this.LeadLawyerChange(this.dialogForm.leadLawyer)
      },
      deep: true
    }
  }
}
</script>

<style lang="less" scoped>
.bankruptcy {
  .select {
  width: 10vw;
  margin-right: 10px;
}
  .date_box {
    .el-icon-date {
      position: absolute;
      top: 50%;
      right: 10px;
      z-index: 9;
      color: #c0c4cc;
      font-size: 14px;
      transform: translateY(-50%);
    }

    /deep/ .el-range__close-icon {
      position: absolute;
      right: 34px;
      top: 54%;
      transform: translateY(-50%);
    }
  }

  .casestatus {
    color: #2bc887;
  }

  .casesresult {
    color: #fe964a;
  }

  .casesrefuse {
    color: #df0d0d;
  }

  .pagination {
    // margin-top: 18px;
    margin: 20px 0px 20px 0px;
    width: 100%;
    overflow: hidden;
    text-align: right;
  }

  .right {
    width: 80%;
    margin: auto;
    margin-top: 3.125rem;
  }

  /* ::v-deep穿透 改变element ui组件样式 */
  ::v-deep .pagination .el-pagination__total {
    float: left;
  }

  ::v-deep .pagination .el-pagination__sizes {
    float: left;
  }
}
// 案件冲突
.conflict {
  width: 98%;
  margin: 12px auto;
  border-radius: 16px;
}

::v-deep .el-table--border th.el-table__cell,
::v-deep .el-table td.el-table__cell {
  border-bottom: none !important;
}

::v-deep .el-table--border .el-table__cell {
  border-right: none !important;
}

::v-deep .el-table td.el-table_cell,
::v-deep .el-table th.el-table__cell.is-leaf {
  border-bottom: 0px solid #ebeef5 !important;
}
/deep/.beig-row {
  background: #e6e5e4 !important;
}
.top {
  width: 100%;
  display: flex;
  color: #3077e6;
  align-items: center;
  font-size: 1.1875rem;
  font-weight: 400;
  padding-left: 3.625rem;
  margin-bottom: 2rem;
}

.icon {
  width: 0.25rem;
  height: 1.125rem;
  background: #3077e6;
  border-radius: 0.5625rem;
  margin-right: 0.3125rem;
}
.copy {
  color: #3077e6;
  border: none;
}
// 表格
.party {
  width: 100%;
  margin: auto;
  ::v-deep .isclient-row {
    background: #fff1dc;
  }

  ::v-deep .el-table__body tr:hover > td {
    background-color: transparent !important;
  }
  // /deep/.el-input.is-disabled .el-input__inner {
  //   background-color: #ffffff;
  //   border-color: #e4e7ed;
  //   color: #000;
  //   cursor: not-allowed;
  // }
}

.party ::v-deep .el-input__inner {
  border: none;
}

//表格
.bankruptcy::v-deep .el-table th.el-table__cell {
  overflow: hidden;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  background-color: #fafafa;
}

.party {
  margin-bottom: 55px;
  margin-left: 5%;

  ::v-deep .el-input__inner {
    border: none;
    padding-left: 0;
    // height: 24px;
    // line-height: 24px;
    text-align: center;
  }

  ::v-deep .el-input--prefix .el-input__inner {
    padding-left: 0px;
  }
}

// /deep/ .el-table tbody tr:hover>td {
//   background-color: #fff !important;
// }

::v-deep tbody tr:hover>td {
  background-color: #fff;
}

/deep/ .el-table th {
  //标题背景色
  background-color: #fafafa;
}

.copy {
  color: #3077e6;
  cursor: pointer;
}

.text {
  display: flex;
  color: #3077e6;
  align-items: center;
  font-size: 1.1875rem;
  font-weight: 400;
  padding-left: 3.625rem;
  margin-bottom: 2rem;
}
</style>